import * as constants from './constants'

export const resetPassword = email => ({
    type: constants.SEND_PASSWORD_RESET_EMAIL,
    email,
})
export const resetPasswordSuccess = email => ({
    type: constants.RESET_PASSWORD_SUCCESS,
    email,
})

export const login = (email, password, remember = false, translate) => ({
    type: constants.LOGIN_INITIATE,
    email,
    password,
    remember,
    translate,
})

// Signup flow
export const initiateSignupFlow = (
    firstName,
    lastName,
    email,
    password,
    news,
    offers,
    nif,
    customerType,
    customerRegNr,
    businessName,
    phone
) => ({
    type: constants.SIGNUP_FLOW_INITIATE,
    firstName,
    lastName,
    email,
    password,
    news,
    offers,
    nif,
    customerType,
    customerRegNr,
    businessName,
    phone,
})

export const signupFlowAddVehicle = (tag, make, model, color, country, state) => ({
    type: constants.SIGNUP_FLOW_ADD_VEHICLE,
    tag,
    make,
    model,
    color,
    country,
    state,
})

export const error = error => ({
    type: constants.SIGNUP_FLOW_ERROR,
    error,
})

export const resetState = () => ({
    type: constants.RESET_SIGNUP_FLOW_STATE,
})

export const setAuthFormState = state => ({
    type: constants.SET_AUTH_CONTAINER_STATE,
    state,
})
